import type { InternalAxiosRequestConfigWithRetry } from './types'

export const requestSuppressNotifyInterceptor = (config: InternalAxiosRequestConfigWithRetry) => {
  if (config.params?._suppressNotify) {
    config._suppressNotify = true
    delete config.params._suppressNotify
  }

  return config
}
